import React from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/common/PageHeader';
import ContainerForm from './components/ContainerForm';
import containerService from '../../services/containerService';
import { ContainerFormData } from '../../types/container';
import { CONTAINER_MESSAGES } from '../../utils/containerConstants';
import '../../styles/container.css';

const ContainerFormPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Handle form submission
  const handleSubmit = async (values: ContainerFormData) => {
    try {
      const response = await containerService.createContainer(values);

      if (response.success) {
        // message.success(t('container.createSuccess'));
        navigate('/container/list');
      } else {
        message.error(response.errorMessage || t('container.createFailed'));
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      message.error(t('common.networkError'));
    }
  };

  // Handle form cancellation
  const handleCancel = () => {
    navigate('/container/list');
  };

  return (
    <div className="container-form-page">
      <PageHeader
        title={t('container.createContainer')}
        className="container-form-header"
      />

      <div className="container-form-content">
        <ContainerForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isEdit={false}
        />
      </div>
    </div>
  );
};

export default ContainerFormPage;